module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/card-corner-purple-4f70b09171efffe3a3762b393247bcf3.svg";